import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Finalizacoes = () => import('./Finalizacoes.vue')
const Finalizacao = () => import('./Finalizacao.vue')
const Entrega = () => import('./../entregas/Entrega.vue')

export default {
    path: 'finalizacoes',
    name: 'Uabs_Finalizacoes',
    component: Finalizacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('UABS-FIN-00')) {
            next()
        }
    },
    children: [{
        path: ':finalizacaoId',
        name: 'Uabs_Finalizacoes_Detalhar',
        component: Finalizacao,
        beforeEnter: (to, from, next) => {
            if (temAcesso('UABS-FIN-01')) {
                next()
            }
        },
        children: [{
            path: ':entregaId',
            name: 'Uabs_Finalizacoes_Entrega',
            component: Entrega,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-UABS-ENTR-01')) {
                    next()
                }
            }
        }]
    }]
}
